import axios from "axios";
import { useState } from "react";
import { Check, HandCoins, Pencil, Plus, Trash2, X } from "lucide-react";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "./ui/alert-dialog";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PayerManager({ payers, onChanged }) {
  const [name, setName] = useState("");
  const [notice, setNotice] = useState("");
  const [editing, setEditing] = useState(null);
  const [draft, setDraft] = useState("");
  const [pendingDelete, setPendingDelete] = useState(null);

  const call = async (fn, ok) => {
    try { await fn(); setNotice(ok); onChanged?.(); }
    catch (e) { setNotice(e?.response?.data?.detail || "İşlem başarısız"); }
  };

  const add = event => {
    event.preventDefault();
    const trimmed = name.trim();
    if (!trimmed) return;
    call(() => axios.post(`${API}/payers`, { name: trimmed }), `Ödeyen eklendi: ${trimmed}`).then(() => setName(""));
  };

  const rename = payer => {
    const next = draft.trim();
    setEditing(null);
    if (!next || next === payer) return;
    call(() => axios.put(`${API}/payers/${encodeURIComponent(payer)}`, { name: next }), `Ödeyen yeniden adlandırıldı: ${next}`);
  };

  const confirmDelete = () => {
    const payer = pendingDelete;
    setPendingDelete(null);
    call(() => axios.delete(`${API}/payers/${encodeURIComponent(payer)}`), `Ödeyen silindi: ${payer}`);
  };

  return (
    <section className="panel account-manager" data-testid="payer-manager">
      <div className="panel-head">
        <div>
          <p className="eyebrow">ÖDEYENLER</p>
          <h3>Parayı gönderen taraflar</h3>
        </div>
        <HandCoins size={18}/>
      </div>
      <form onSubmit={add} className="group-form">
        <input data-testid="new-payer-input" placeholder="Ör: BTB Tours Türkiye" value={name} onChange={e => setName(e.target.value)}/>
        <button className="outline-btn" data-testid="add-payer-button" type="submit"><Plus size={16}/> Ekle</button>
      </form>
      <div className="group-chips" data-testid="payer-chips">
        {payers.map(payer => editing === payer ? (
          <span key={payer} className="group-tag editing" data-testid={`payer-edit-${payer}`}>
            <input autoFocus data-testid="payer-rename-input" value={draft} onChange={e => setDraft(e.target.value)}
              onKeyDown={e => { if (e.key === "Enter") { e.preventDefault(); rename(payer); } if (e.key === "Escape") setEditing(null); }}/>
            <button type="button" className="chip-btn" data-testid="payer-rename-save" title="Kaydet" onClick={() => rename(payer)}><Check size={12}/></button>
            <button type="button" className="chip-btn" data-testid="payer-rename-cancel" title="Vazgeç" onClick={() => setEditing(null)}><X size={12}/></button>
          </span>
        ) : (
          <span key={payer} className="group-tag" data-testid={`payer-chip-${payer}`}>
            {payer}
            <button type="button" className="chip-btn" title="Yeniden adlandır" data-testid={`payer-rename-${payer}`}
              onClick={() => { setEditing(payer); setDraft(payer); }}><Pencil size={11}/></button>
            <button type="button" className="chip-btn danger" title="Sil" data-testid={`payer-delete-${payer}`}
              onClick={() => setPendingDelete(payer)}><Trash2 size={11}/></button>
          </span>
        ))}
      </div>
      <small className="hint">Ödeyen, tahsilatı gönderen taraftır (ör. BTB Tours). Tahsilat tutarı buradan seçilen ödeyen altında bir veya birden fazla otel hesabına dağıtılır.</small>
      {notice && <small data-testid="payer-notice" className="group-notice">{notice}</small>}

      <AlertDialog open={!!pendingDelete} onOpenChange={open => !open && setPendingDelete(null)}>
        <AlertDialogContent data-testid="payer-delete-dialog">
          <AlertDialogHeader>
            <AlertDialogTitle>Ödeyen silinsin mi?</AlertDialogTitle>
            <AlertDialogDescription>
              <b>{pendingDelete}</b> silinecek. Bu ödeyene bağlı tahsilat varsa silme işlemi reddedilir.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel data-testid="payer-delete-cancel">Vazgeç</AlertDialogCancel>
            <AlertDialogAction data-testid="payer-delete-confirm" className="danger-action" onClick={confirmDelete}>Evet, sil</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </section>
  );
}
